import Immutable from 'immutable/dist/immutable';
import {SET_EMERGENCY_DETAILS, SET_EMERGENCY_PERSONNEL, SET_IS_LOADING} from '../actions/emergencyPersonnelActions';
import {SET_MEETING_IS_LOADING} from "../actions/meetingActions";

const initialState = Immutable.Map({
  emergencyPersonnel: {},
  details: {},
});

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_LOADING:
      return state.setIn(['isLoading'], action.isLoading);
    case SET_EMERGENCY_PERSONNEL:
      return state.setIn(['emergencyPersonnel'], action);
    case SET_EMERGENCY_DETAILS:
      return state.setIn(['details'], action.emergencyDetails);
    default:
      return state;
  }
};
